import { createSelector } from 'reselect';

/*
this selector is to select value from coreZone in case when data is fetched from search API.
and when data is directly fected from iris.
irisBreadCrumbInfo: data fetching from iris
*/

const getAltMessageFromIris = (state, selfProps = {}) =>
    selfProps.copyBlock || selfProps.html || '';

export const getAltMessage = createSelector([getAltMessageFromIris], (irisAltMessage) => {
    return irisAltMessage;
});

export default getAltMessage;
